import React from 'react'
import PropTypes from 'prop-types'
import onClickOutside from 'react-onclickoutside'
import UserActions from './component'
import {
  CANCEL_PENDING_INVITE_TEXT,
  REMOVE_USER_TEXT,
  SEND_REMINDER_TEXT,
  CHANGE_TO_TEXT,
} from './constants'
import { InvitationStatus, AccessLevel, capitalize } from '../../lib/util'

export class UserActionsContainer extends React.Component {
  state = {
    areActionsOpen: false,
  }

  toggleActions = () => {
    this.setState({ areActionsOpen: !this.state.areActionsOpen })
  }

  handleClickOutside = () => {
    if (this.state.areActionsOpen) {
      this.setState({
        areActionsOpen: false,
      })
    }
  }

  removeUser = () => {
    const { user, handleCancelUserAccess } = this.props
    handleCancelUserAccess(user)
    this.setState({ areActionsOpen: false })
  }

  remindUser = () => {
    const { user, remindSiteUser } = this.props
    remindSiteUser(user)
    this.setState({ areActionsOpen: false })
  }

  render() {
    const { applicableRoles, handleGrantNewRole, user } = this.props
    const currentRole = user.roles[0]
    const inactiveRoles = applicableRoles.filter(
      applicableRole =>
        currentRole &&
        applicableRole.role.toLowerCase() !== currentRole.toLowerCase(),
    )
    const isActive = user.status === InvitationStatus.Active
    const isInvited = user.status === InvitationStatus.Invited
    let actions = []
    if (isActive || isInvited) {
      actions = inactiveRoles.map(inactiveRole => {
        const text = `${CHANGE_TO_TEXT} ${AccessLevel[inactiveRole.name].friendlyName}`
        return {
          text,
          handler: () => {
            handleGrantNewRole(
              {
                ...user,
                sendEmail: true,
              },
              capitalize(inactiveRole.role.toLowerCase()),
            )
            this.setState({ areActionsOpen: false })
          },
          type: `grant-${inactiveRole.role.toLowerCase()}`,
        }
      })
    }

    actions.push({
      text: isActive ? REMOVE_USER_TEXT : CANCEL_PENDING_INVITE_TEXT,
      handler: this.removeUser,
      type: 'remove',
    })

    if (isInvited) {
      actions.unshift({
        text: SEND_REMINDER_TEXT,
        handler: this.remindUser,
        type: 'remind',
      })
    }

    return (
      <UserActions
        actions={actions}
        areActionsOpen={this.state.areActionsOpen}
        email={user.inviteEmail}
        toggleActions={this.toggleActions}
      />
    )
  }
}

UserActionsContainer.propTypes = {
  applicableRoles: PropTypes.array.isRequired,
  handleCancelUserAccess: PropTypes.func.isRequired,
  handleGrantNewRole: PropTypes.func.isRequired,
  remindSiteUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}

export default onClickOutside(UserActionsContainer)



// WEBPACK FOOTER //
// ./src/components/UserActions/container.js